











import { Component } from "vue-property-decorator";
import InputProps from "@/mixins/InputProps";
import BaseInput from "@/components/BaseInput";

@Component({ name: "InputPassword", components: { BaseInput } })
export default class InputPassword extends InputProps {
  public secure = true;

  get passwordIcon() {
    return this.secure ? "sci-eye-off" : "sci-eye";
  }
}
